import React, {Component} from 'react';
import {
    Dialog,
    DialogContent,
    Button,
    Typography,
    DialogActions,
    Toolbar,
    AppBar,
} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles/index';
import {bindActionCreators} from 'redux';
import {UecareDropdown, UecareInput} from '../../../../components';
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxUseRecord from "../../../../store/actionreducers/useRecord";
import {connect} from 'react-redux';

const initState = {
    mission_type: {id: 0},
    min: ''
};

class VipDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {...initState};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (!prevProps.dataDialog.props.open && this.props.dataDialog.props.open) {
            this.setState({...initState});
        }
    }

    handleChange = (name, value) => {
        this.setState({[name]: value});
    };

    closeDataDialog = () => {
        this.props.closeEditDataDialog();
    };

    canBeSubmitted() {
        return this.state.mission_type.id > 0;
    }

    render() {
        const {classes, dataDialog, missionTypes} = this.props;
        const {updateBasicSetting} = this.props;

        return (
            <Dialog className={classes.root} {...dataDialog.props} onClose={this.closeDataDialog} fullWidth
                    maxWidth="xs">

                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">
                            修改APP服務設定
                        </Typography>
                    </Toolbar>
                </AppBar>

                <DialogContent classes={{root: "p-24"}}>

                    <UecareDropdown
                        label='服務類型'
                        icon='star'
                        name='missionTypeId'
                        id='missionType'
                        className={classes.formControl}
                        value={this.state.mission_type.id}
                        options={missionTypes}
                        onChange={(event, selectedOption) => {
                            this.handleChange('mission_type', selectedOption);
                        }}/>

                    <UecareInput
                        label='分鐘/次'
                        icon='score'
                        name='min'
                        id='min'
                        inputType='number'
                        className={classes.formControl}
                        value={this.state.min}
                        onChange={(event) => {
                            this.handleChange('min', event.target.value);
                        }}/>

                </DialogContent>

                <DialogActions className="justify-between pl-16">
                    <Button
                        variant="raised"
                        color="primary"
                        disabled={!this.canBeSubmitted()}
                        onClick={async () => {
                            try {
                                await updateBasicSetting({...this.state});
                                this.closeDataDialog();
                            } catch (e) {
                                console.warn('you got an error = ', e);
                            }
                        }}
                    >
                        修改
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = theme => ({
    root: {},
    button: {
        margin: theme.spacing.unit,
    },
    formControl: {
        marginBottom: 24
    },
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeEditDataDialog: ReduxGlobal.ActionCreator.closeEditDataDialog,
        updateBasicSetting: ReduxUseRecord.ActionCreator.updateBasicSetting,
    }, dispatch);
}

function mapStateToProps({global: {dataDialog}, missionType}) {

    return {
        dataDialog,
        missionTypes: missionType.list,
    }
}


export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(VipDialog));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/missionConfig/MissionConfigsDialog.js